import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { withLocalize } from "react-localize-redux";
import { Grid } from '@mantine/core';
import { Space  } from '@mantine/core';
import { Center } from '@mantine/core';
import IconDocumentStatus from '../partials/IconDocumentStatus';
import {extractOldQuaterlyReport} from '../../actions/oldQuaterlyReport';
import { createQuaterlyReport, fetchQuaterlyReport, getAutocompleteList } from '../../actions/quaterlyReport';

class QuaterlyReportList extends React.Component {

    constructor(props) {
        super(props);
        this.state = { }
    }


    renderIcon(index){
        let progress = 0
        // let validationInformation = {}
        if(this.props.itemList[index].content){
            // validationInformation = this.props.itemList[index].validationInformation
            progress = this.props.itemList[index].content.progress
        }
        return(
            <IconDocumentStatus style={{marginRight: "10px", height: "20px", width: "20px", display: "inline-block"}}
                progression={progress}
                validationInformation={{"user":"","timestamp":"","validationStatus":"document_validation_status_draft"}}
                infovisible="false"
                kind="project"
                isincompleted={this.props.isincompleted}
                translate={this.props.translate}
            /> 
        )

    }


    renderListOfRaportName(){
        const divs = [];
        let listDate = [];
        this.props.itemList.forEach((rapport, index) => {
            const handleExtract = rapport.filename ? ()=>{this.props.extractOldQuaterlyReport(rapport._id.toString())} : ()=>{}
            listDate.push(rapport.updatedAt);
            divs.push(
            <React.Fragment key={rapport.id}>
                <Grid.Col span={12} style={{maxHeight:"1px"}}>
                    <div style={{borderBottom: '1px solid #ccc'}}></div>
                </Grid.Col>
                <Grid.Col span={2}>
                    <Center>
                        <div style={{ padding: "3px"}}>
                            {this.renderIcon(index)}
                        </div>
                    </Center>
                </Grid.Col>
                <Grid.Col span={10}>
                    {
                        rapport.filename ?
                            <button className="bloc-content" onClick={handleExtract.bind(this)}>
                                <u>{rapport.filename}</u>
                            </button>
                        :                     
                        <Link style={{"textDecoration": "none"}} to={{pathname:"/quaterlyReport/" + rapport.id, state:{listDate}}} >
                        <p className="bloc-content">
                            {this.props.translate("quaterlyReport.list.name")} 
                            { rapport.content.title && rapport.content.title.length>0 ? 
                            <> { (rapport.content.title).substring(0, 7) }</>
                            :
                            <> {rapport.createdAt.substring(0, 10)}</> }
                        </p>
                        </Link>
                    }

                    
                </Grid.Col>
            </React.Fragment>
        );
        });

        if(divs.length>0){
            return(
                <Grid gutter={4} key="999" columns={12}> 
                    {divs}
                    <Grid.Col span={12} style={{maxHeight:"1px"}}>
                        <div style={{borderBottom: '1px solid #ccc'}}></div>
                    </Grid.Col>
                </Grid>
            )
        } else {
            return(<></>)
        }
    }

 
    render() {

        return(
            <div>
                <Space h="md" />
                {this.renderListOfRaportName()}
                <Space h="md" />
            </div>
        )
    }
}



function mapStateToProps(state) {
    return {
        quaterlyReport: state.quaterlyReport,
        message: state.program.message,
    }
}



export default connect(mapStateToProps, {createQuaterlyReport,fetchQuaterlyReport,getAutocompleteList,extractOldQuaterlyReport})(withLocalize(QuaterlyReportList));
